<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link
              :to="{ name: 'View Business Entity', params: { id: entityId } }"
              class=""
            >
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("entity.label.view_ticket") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row" v-if="ticket.status === 'OPEN'">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      type="border"
                      @click="ticketPopupEdit = true"
                      size="small"
                      >{{ $t("entity.label.edit_ticket") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      type="border"
                      @click="removeTicket(id)"
                      size="small"
                      >{{ $t("entity.label.close_ticket") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("entity.label.ticket_number") }}</b>
                </td>
                <td>{{ ticket.ticketNumber }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.id") }}</b>
                </td>
                <td>{{ ticket.id }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.priority") }}</b>
                </td>
                <td>{{ ticket.priority }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.status") }}</b>
                </td>
                <td>{{ ticket.status }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.title") }}</b>
                </td>
                <td>{{ ticket.title }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.ticket_date") }}</b>
                </td>
                <td>{{ ticket.ticketDate | formatedate }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.last_comment") }}</b>
                </td>
                <td>{{ ticket.lastComment }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.problem_description") }}</b>
                </td>
                <td>{{ ticket.problemDescription }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.sub_category") }}</b>
                </td>
                <td>{{ ticket.subCategoryStatus }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("entity.label.comment_date") }}</b>
                </td>
                <td>{{ ticket.Comment_date | formatedate }}</td>
              </tr>

              <tr>
                <td class="border-none">
                  <b>{{ $t("entity.label.file") }}</b>
                </td>
                <td class="border-none">
                  <a @click.stop="downloadDocument">{{ ticket.fileName }}</a>
                </td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.CloseTicket')"
        :active.sync="cancelTicketPopup"
        class="popup-close mid-popup"
      >
        <form ref="form">
          <div class="vx-col w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("entity.label.status") }}<span class="required"> *</span></small
              >
              <v-select
                label="mCodeValue"
                :options="cancelStatus"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="cancelObj.status"
                :reduce="(userName) => userName.id"
                class="min-w-200 w-full mb-2"
              />
            </div>
          </div>
          <div class="vx-col sm:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("entity.label.ResolutionDescription")
                }}<span class="required"> *</span></small
              >
              <vs-textarea
                class="w-full textbox"
                v-model="cancelObj.resolutionDescription"
                hint="Please provide as much detail as possible so we can best assist you."
              />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="cancelTicket"
                class="footerButton-next mt-4 mb-4"
                style="top: 0px"
                >{{ $t("entity.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <EditTicket
      :active="ticketPopupEdit"
      @closePopup="
        ticketPopupEdit = false;
        getByIdticket();
      "
      :entityId="entityId"
      :id="id"
    />
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import EditTicket from "./EditTicket.vue";
export default {
  data() {
    return {
      ticket: {},
      id: 0,
      entityId: 0,
      routeLink: `/view_entity/`,
      ticketPopupEdit: false,
      cancelTicketPopup: false,
      cancelObj: {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      },
    };
  },
  components: {
    EditTicket,
    "v-select": vSelect,
  },
  computed: {},
  methods: {
    async getByIdticket() {
      try {
        this.ticket = await this.$store.dispatch("entity/getTicketInfo", {
          entityId: this.entityId,
          id: this.id,
        });
      } catch (error) {
        this.$toasted.error("something went wrong!");
      }
    },

    downloadDocument() {
      this.$store
        .dispatch("entity/downloadTicketFile", {
          entityId: this.entityId,
          id: this.ticket.DocumentId,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.ticket.fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(console.error);
    },
    async removeTicket(id) {
      this.cancelTicketPopup = true;
      this.id = id;
      this.cancelObj = {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      };
    },
    async cancelTicket() {
      try {
        (this.cancelObj.ticketURL = `${this.ticket.ticketURL2}${this.entityId}`),
          await this.$store.dispatch("entity/cancelTicketAction", {
            id: this.id,
            data: this.cancelObj,
          });
        this.cancelTicketPopup = false;
        this.getByIdticket();
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
    async getCancelTicketTemplate() {
      try {
        this.cancelStatus = await this.$store.dispatch(
          "entity/getCancelTicketTemplate"
        );
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.entityId = this.$route.params.entityId;
    this.routeLink = `${this.routeLink}${this.entityId}`;
    this.getByIdticket();
    this.getCancelTicketTemplate();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
